<template>
  <div>
    <span
      class="question-number"
      v-for="(question, index) in questions"
      :key="question.id"
      @click="scrollQuestionIntoView(question)">
      <!-- todo 使用 selectedOptionId 变量，是因为正常情况下 forEach 不会监听答案选项的变化去更新内容 -->
          <el-tooltip
            effect="dark"
            :content="question.title | stripTags"
            placement="top"
            :enterable="false">
            <el-tag
              size="small"
              :type="getQuestionStatus(question.id, answers[index].selectedOptionId)">
              <span>{{index+1}}</span>
              <div :class="['badge', getReferQuestionStatus(question.id, answers[index].selectedOptionId)]"></div>
            </el-tag>
          </el-tooltip>
    </span>
  </div>
</template>

<script>
import QuestionReview from '../../question-review.js'

export default {
  mixins: [],
  inject: ['page'],
  props: {},
  data () {
    return {}
  },
  computed: {
    answers () {
      return this.page.answers
    },
    questions () {
      return this.page.questions
    },
  },
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    scrollQuestionIntoView ({id}) {
      QuestionReview().scrollQuestionIntoView(id)
    },
    getQuestionStatus (id) {
      // 跳过
      if (QuestionReview().isJumped(id)) {
        return 'warning'
      }
      // 已审核
      if (QuestionReview().isReviewed(id)) {
        // 审核通过
        if (QuestionReview().isPassed(id)) {
          return 'success'
        } else {
          return 'danger'
        }
      }
      return 'info'
    },
    getReferQuestionStatus (id) {
      let referIds = QuestionReview().getReferId(id)
      let status = ''
      for (const questionId of referIds) {
        if (QuestionReview().isReviewed(questionId)) {
          // 审核未通过
          if (QuestionReview().isNotPassed(questionId)) {
            return 'danger'
          } else {
            status = 'success'
          }
        }
      }
      return status
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/QuestionNumber/index.vue